import  { CARGAR_GASTOSIMPORTACION } from './actionTypes';
import global_axios from '../../funciones_globales/interaccionapi';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';

export const cargar_GastosImportacion = (importacion) => {
    return (dispatch) => {
        
        let config_request = {
			method: 'GET',
			url: '/importaciones/' + importacion + '/gastosimportacion',
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
        .then( response => {
			dispatch({
				type: CARGAR_GASTOSIMPORTACION,
                data: {gastos_import_detalle: response.data},	
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar gastos de importación', mensaje: msgError}
			});
		});
    }
}

